import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { StatieItems } from "../../components";
import { ParcelItems } from "../../components/charts/ParcelItems.chart";
import { MaterialsRevenue } from "../../components/charts/MaterialsRevenue.chart";
import { CumulativeUsersOverTime } from "../../components/charts/CumulativeUsersOverTime.chart";
import { useMemo } from "react";

function SummaryDashboardScreen() {
  const emptyFilters = useMemo(() => [], []);
  const emptyStores = useMemo(() => [], []);
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const currentMonth = useMemo(() => new Date().getMonth(), []);
  const currentWeek = useMemo(() => new Date(), []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Summary Graphs
        </h1>
        <div className="flex" />
      </div>
      <CumulativeUsersOverTime
        periodProp="all"
        yearProp={currentYear}
        quarterProp="Q1"
        monthProp={currentMonth}
        weekProp={currentWeek}
        selectedFiltersProp={emptyFilters}
        selectedStoresProp={emptyStores}
        showTargets={true}
      />
      <StatieItems />
      <ParcelItems />
      <MaterialsRevenue />
    </div>
  );
}

export default withProtectedRoute(SummaryDashboardScreen);
